module.exports = __webpack_public_path__ + "static/media/banff-43.12594b48.jpg";